<!-- <p-panel [style]="{'margin-bottom':'20px'}">
  <- mostrar al hacer click en componente plyca-error-counter?
    <p-overlayPanel #errTooltip appendTo="body" [style]="{'max-width':'40%'}">
    <plyca-validation-group [errorGroup]="errors"></plyca-validation-group>
  </p-overlayPanel> ->
  <p-header>
    <span>
      <i class="fa fa-chevron-right" aria-hidden="true" id="{{this.formService.getFormGroupId(formGroupConfig.group.id)}}"></i>&nbsp;{{getDescription()}}
    </span>
    <plyca-error-counter *ngIf="displayErrorCount" [errorGroup]="errors"></plyca-error-counter>
  </p-header> -->
<!-- DIV FICTICIO CON ID PARA PODER HACER SCROLL AUTOMATICO -->
<div id="{{ this.formService.getFormGroupId(formGroupConfig.group.id) }}" class="{{formGroupConfig.group.styleClass}}">
  <!-- CABECERA DEL GRUPO (SE MUESTRA EN FUNCION DE UN PARAMETRO) -->
  <h3 class="groupElement" *ngIf="showHeader">
    <span>
      <i class="fa fa-chevron-right" aria-hidden="true"></i>&nbsp;{{ getDescription() }} </span>

    <plyca-error-counter *ngIf="displayErrorCount" [errorGroup]="errors"></plyca-error-counter>
  </h3>
  <!-- FORMGROUP -->
  <ng-container *ngIf="createForm; else formElementLoop">
    <form [formGroup]="formGroup">
      <ng-container *ngTemplateOutlet="formElementLoop"></ng-container>
    </form>
  </ng-container>
  <!-- </p-panel> -->
</div>
<ng-template #formElementLoop>
  <ng-container *ngIf="formConfigFinished">
    <ng-container *ngFor="let field of formGroupConfig.group.fieldList; let i = index">
      <formElement [model]="formGroupConfig.model" [formGroup]="formGroup" [fieldConfig]="field"
        [functions]="formGroupConfig.functions" [templates]="formGroupConfig.templates" [errors]="errors"
        (loaded)="this.markElementAsLoaded(field.id)" [changeDectectionTimestamp]="lastChangesApplied"
        (updateGroup)="sendUpdateView($event)" (visibleEvt)="updateVisibility($event)"></formElement>
    </ng-container>
  </ng-container>
</ng-template>